export default __webpack_public_path__ + "static/media/gallery-flying.9617a1ea.webp";